import { CalendarManager, Dividend } from '@benzinga/calendar-manager';
import { DividendsQueryParamsInput, normalizeDividendsQueryParams } from '@benzinga/calendar-dividends-manager';
import { Session } from '@benzinga/session';
import { injectLogos } from '../lib/utils';
import { logCalendarFetchFailure } from '../lib/utils/logCalendarFetchFailure';

const compareExDividendDatesAsc = (left: Dividend, right: Dividend) => {
  const leftDate = left.ex_dividend_date ?? '';
  const rightDate = right.ex_dividend_date ?? '';
  if (!leftDate && !rightDate) return 0;
  if (!leftDate) return 1;
  if (!rightDate) return -1;
  return leftDate.localeCompare(rightDate);
};

const fetchDividends = (
  session: Session,
  params: DividendsQueryParamsInput = {},
  injectTickersLogos = true,
  pageSize = 100,
): Promise<Dividend[]> => {
  const query = normalizeDividendsQueryParams({ ...params, pageSize });

  return session
    .getManager(CalendarManager)
    .getCalendarData('dividends', query)
    .then(res => {
      if (res.ok?.length) {
        const sorted = [...res.ok].sort(compareExDividendDatesAsc);
        return injectTickersLogos ? injectLogos(sorted) : sorted;
      }
      return [];
    })
    .catch(error => {
      logCalendarFetchFailure('dividends', error);
      return [];
    });
};

export { fetchDividends };
